import constants from "../constants";
import store from "../store";
import util from "../util";

export function updateSizeGuide($target, message) {
  let $sizeGuide = $target.find('.size-guide');
  if ($sizeGuide.length === 0) {
    $target.append('<div class="size-guide"></div>');
    $sizeGuide = $target.find('.size-guide');
  }
  $sizeGuide.html(message);
}

export function getElementsPositions($elements) {
  let isExistingGroup = false;

  let top = Number.MAX_SAFE_INTEGER;
  let left = Number.MAX_SAFE_INTEGER;
  let bottom = 0;
  let right = 0;
  let width = 0;
  let height = 0;
  let maxWidthLeft = 0;
  let maxHeightTop = 0;

  $elements.forEach(($element) => {
    const parentBoundingRect = $element.parent().get(0).getBoundingClientRect();

    const elementBoundingRect = $element.get(0).getBoundingClientRect();

    let elTop = elementBoundingRect.top - parentBoundingRect.top;
    let elLeft = elementBoundingRect.left - parentBoundingRect.left;
    let elWidth = elementBoundingRect.width;
    let elHeight = elementBoundingRect.height;

    if (constants.SCALED_ZOOM_APPROACH) {
      const zoom = store.getState().zoom / 100;

      elTop = elementBoundingRect.top/zoom - parentBoundingRect.top/zoom;
      elLeft = elementBoundingRect.left/zoom - parentBoundingRect.left/zoom;
      elWidth = elementBoundingRect.width/zoom;
      elHeight = elementBoundingRect.height/zoom;
    }

    if (elWidth > width) {
      width = elWidth;
      maxWidthLeft = elLeft;
    }

    if (elHeight > height) {
      height = elHeight;
      maxHeightTop = elTop;
    }

    if (top > elTop) top = elTop;
    if (left > elLeft) left = elLeft;

    if (bottom < elTop + elHeight) bottom = elTop + elHeight;
    if (right < elLeft + elWidth) right = elLeft + elWidth;

    if ($element.parents('.group').length > 0) {
      isExistingGroup = true;
    }
  });

  return {isExistingGroup, top, left, bottom, right, width, height, maxWidthLeft, maxHeightTop};
}

export function updateElementPercentPosition($element, top, left, pWidth, pHeight) {
  const dims = util.getActiveDimensions();

  const pageWidth = pWidth || dims.width;
  const pageHeight = pHeight || dims.height;

  const percentLeft = util.pixelToPercent(left, pageWidth);
  const percentTop = util.pixelToPercent(top, pageHeight);

  $element.css('top', `${percentTop}%`);
  $element.css('left', `${percentLeft}%`);
}
